<template>
  <div>
    <div class="form-group">
<label>{{ title }}</label>
</div>
    <div class="form-group">
      <label class="inbox-label">{{ t('insurance.auto_drive_age') }}</label>
      <input
        :fieldTitle="title + '_' + t('insurance.auto_drive_age', {}, 'zh')"
        :fieldname="'age_' + id"
        :required="id==='1'"
        class="form-control"
        name="age"
        type="number"
        min="16"
        max="100"
        maxlength="3"
        fieldType="text"
>
    </div>
    <div class="form-group">
      <label class="inbox-label">{{ t('insurance.auto_position') }}</label>
      <input
        :required="id==='1'"
        :fieldTitle="title + '_' + t('insurance.auto_position', {}, 'zh')"
        :fieldname="'position_' + id"
        class="form-control"
        name="position"
        maxlength="200"
        type="text"
        fieldType="text"
>
    </div>
  </div>
</template>
<script>
export default {
  name: "DriverForm",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  computed: {},
  mounted: function () { },
  methods: {
  },
};
</script>
